import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { routing } from './pages.routing';
import { NgaModule } from '../theme/nga.module';
import { PagesComponent } from './pages.component';
import { AuthService } from '../shared/auth.service';
import { AuthGuardService } from '../shared/authguard.service';
import { JwtHelper } from 'angular2-jwt';
import { SuperAdminService } from '../shared/super-admin.services';
import { StaffService } from '../shared/staff.services';
import { WindowService } from '../shared/window.service';
// import { ListIComponent } from './admin/fees/list-i/list-i.component';

@NgModule({
  imports: [
    CommonModule,
    NgaModule,
    routing
  ],
  declarations: [
    PagesComponent,
    // ListIComponent,
   // AngularFileUploaderComponent
  ],
  providers: [
    AuthService,
    AuthGuardService,
    JwtHelper,
    SuperAdminService,
    StaffService,
    WindowService
  ]
})
export class PagesModule {
}
